import { render } from "./UiPagination.vue?vue&type=template&id=2cd7ec6d"
import script from "./UiPagination.vue?vue&type=script&lang=js"
export * from "./UiPagination.vue?vue&type=script&lang=js"
script.render = render

export default script